import React from "react";
import "./SecondaryButton.scss";

const SecondaryButton = ({ className, icon, children, ...props }) => {
  return (
    <button
      {...props}
      className={`aco-secondary-button ${className ? className : ""}`}
    >
      <span>{children}</span> {icon ? icon : null}
    </button>
  );
};

export default SecondaryButton;
